import { Button } from "@tql/ui-components-react/tql/buttons";
import { copy_01 } from "@tql/ui-components-react/untitled/icons";
import { useNavigate } from "react-router";

import { routes } from "~/app/routes/web-routes.ts";

type CopyQuoteButtonProps = {
	readonly quoteId: number;
	readonly showLabel?: boolean;
};

export const CopyQuoteButton = ({
	quoteId,
	showLabel = false,
}: CopyQuoteButtonProps) => {
	const navigate = useNavigate();

	const handleCopyQuoteClick = () => {
		navigate(
			routes.quoteDetailsWithId.replace(":quoteId", quoteId.toString()),
			{
				state: { isRerate: true },
			},
		);
	};

	const buttonProps = {
		onClick: handleCopyQuoteClick,
		svgIcon: copy_01,
		title: "Copy Quote",
		variant: "secondary" as const,
	};

	if (!showLabel) {
		return <Button {...buttonProps} />;
	}

	return <Button {...buttonProps}>Copy Quote</Button>;
};
